<template>
    <div class="drawerLayer" v-show="visible">
        <div class="mask" @click="close();"></div>
        <div class="bottomDrawer white_bg">
            <div class="generalPagePaddingH">
                <header class="header paddingV16">
                    <div class="flexLayout">
                        <div style="width: 16px;"></div>
                        <div class="flexItem alignCenter grey10 fWeight600">学分兑换</div>
                        <div style="width: 16px;">
                            <i class="icon closeIcon" @click="close()"></i>
                        </div>
                    </div>
                </header>
                <div class="body" style="margin-top: 10px; padding-bottom: 34px;">
                    <div>
                        <span class="font14r fWeight600 grey20">我的学分:</span>
                        <span class="fWeight600 grey20">{{userTotalIntegral}}</span>
                    </div>
                    <div class="marginT24 roundBorder8 bgGrey98">
                        <div class="paddingV8 paddingH12">
                            <div class="flexLayout">
                                <div style="width: 82px">
                                    <img class="cover roundBorder4" width="82" height="53" :src="product.image"/>
                                </div>
                                <div class="flexItem" style="padding-left: 10px;">
                                    <div class="paddingV4">{{product.title}}</div>
                                    <div class="clearfix" style="line-height: 17px;">
                                        <span class="font10r fWeight600 fl" style="color: hsla(0, 0%, 7%, 1)">学分:</span>
                                        <span class="font12r fWeight600 fl grey20">{{product.integralValue}}</span>
                                        <span class="font10r fWeight400 grey60 fr">x1</span>
                                    </div>
                                </div>
                            </div><!-- end .flexLayout -->
                            <div class="marginT12 alignR">
                                <span class="font10r fWeight600" style="color: hsla(0, 0%, 7%, 1)">小计:</span>
                                <span class="font14r fWeight600" style="color: hsla(0, 100%, 60%, 1)">{{product.integralValue}}</span>
                                <span class="font10r fWeight600" style="color: hsla(0, 100%, 60%, 1)">学分</span>
                            </div>

                        </div>
                    </div><!-- end .bgGrey98 -->
                    <div class="alignC" style="margin-top: 60px;">
                        <button class="convertButton white f16" @click="submit()">
                            <template v-if="userTotalIntegral >= product.integralValue">
                                <div class="" style="line-height: 22px;">立即兑换</div>
                                <div style="font-size: 9px; line-height: 13px;">（合计：{{product.integralValue}}学分）</div>
                            </template>
                            <template v-else>
                                <div @click="$router.push('/operationMain/integral')" style="line-height: 32px;">学分不足，点击领取</div>
                            </template>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import drawerPart from '../part/drawerPart';

// platformApi
import paymentManager   from '@comp/platformApi/paymentManager';
import timerManager     from '@comp/platformApi/timerManager';
import requestManager   from '@comp/platformApi/requestManager';

// data
import externalApp from '@data/externalApp';

// util
import consoleHelper from '@util/consoleHelper';
import objectHelper from '@util/objectHelper';
import appHelper from '@util/appHelper';

const config = {
    apiConfig : {
        submitOrder : {
            url : "portal/v4/order/pay",
            params : {
                bizId:'',
                coinType: 'INTEGRAL',
                orderBizType: 'FREE_LEARN_VOD',
                payWay: paymentManager.getPaymentWay()
            },
            method : 'post'
        }
    }
};

export default {
    name: "courseConvertDrawer",
    extends : drawerPart,
    props : {
        userTotalIntegral : Number
    },
    data() {
        return {
            product : {
                id : '',
                title : '',
                image : '',
                integralValue : '',
            },
            apiConfig : config.apiConfig
        }
    },
    methods : {
        setProduct(productData) {
            this.product = productData;
        },
        submit() {
            if (this.userTotalIntegral < this.product.integralValue)
            {
                // redirect

                return;
            }

            let params = objectHelper.merge(this.apiConfig.submitOrder.params || {}, {
                bizId : this.product.id
            });
            let options = objectHelper.merge(this.apiConfig.submitOrder, {
                params : params
            });
            requestManager.request(options, (error, result) => {
                if (error)
                {
                    consoleHelper.logError(error);
                    return;
                }

                if (result.errorCode)
                {
                    appHelper.showHint(result.errorCode + ': ' + result.msg);
                    consoleHelper.logError(result.errorCode + ': ' + result.msg);
                    return;
                }

                appHelper.showHint('兑换成功！');
                this.close();

                // redirect
                timerManager.setTimeout(() => {
                    let url = '/learn/course/' + this.product.vodId;
                    appHelper.redirect(url);
                }, 1500)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    .closeIcon {
        width: 14px;
        height: 14px;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACFklEQVRoge2ZQU/bMBhALWCdhPgZvfnk7305k/MkdhgwumqI/vkxpE2CaTsgtaG7xCjqbEiKnWRSntRDqzp+L0nbNDZmYmIiCHBsrT0Z2sNaewIcdxqkqh+AP8CjiHzO5PYqIvIJeAR+q2rZdtwhcAts68daVc8zegZR1Qtg3fC4NcYcvDoQeAc8NAb6iIv82s8OlzvyW+DeGHPYdgNLEakCEdmPRGDPb4EnEbnqtCERWfUdISJXEfnVvhsMRgCXadWf5TfJ5BsbDkVsnHNf0qhnlG9MkC0iu3xjouQRIfl6jpuU7s0Jk0XE5FX1Ood7c+I3Rwwm3xDYO8I5txhU3rNPBLAEqsHlPV0iRifvaRMxWnnPSxEheWA88p5YROC1ClgO7RtERL4GflX/D3lPfdr8E1EfiXHLG2OMql4HTpvkF4BZeEF+/BEh+fr57uk0vojInq+AZeQzMZ6IiPzGObfw74lFJL/m70pMPvQHPBQhItVgEV3kPaOJAG66ynsGjxCRFfC0j7xnsIgU8p7eI1LKe3qLiMiv3yLvyR4Rk095szdbRB/ynuQRfcp7kkWo6qJveQ+BtYE6ot1KkbV2BvzalSfDHekYkTWCe2vtrM34A+B786uyz9UZj6qe70R8M22WmIwxpiiKU+AO+CEiZ3lV4zjnPgI/gbuiKE47DS7L8mg+n7/P5NYaa+2sLMujoT0mJsbKX2RBsPwpegpvAAAAAElFTkSuQmCC');
    }
}
.convertButton {
    width: 298px;
    height: 42px;
    line-height: 18px;
    background: linear-gradient(168deg, #FF6434 0%, #FF3452 100%);
    border-radius: 21px;
    border: none;
    padding: 4px 0;
}
</style>
